import React, { useContext } from 'preact/compat';
import { SelfServiceFormProps } from './types';

export const SelfServiceFormContext = React.createContext<SelfServiceFormProps | null>(null);

export function useSelfServiceFormContext() {
    const context = useContext(SelfServiceFormContext);

    if (context === null) {
        throw new Error('The useSelfServiceFormContext() must be used inside a SelfServiceFormContext.Provider component.');
    }

    return context;
}
